import axios from 'axios';

import { CLIENTES } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const filtrarClientes = (opcion) => dispatch => {
    dispatch({
        type: CLIENTES.FILTROS,
        payload: opcion
    });
}

export const buscarClientes = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/clientes/listar`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CLIENTES.BUSCAR,
            payload: res.data.clientes
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const buscarClientesPacientes = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/clientes/listar_coincidencias`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CLIENTES.BUSCAR_COINCIDENCIAS,
            payload: res.data.resultados
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerCliente = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/clientes/perfil`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CLIENTES.DETALLES,
            payload: res.data.cliente
        });
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarCliente = () => dispatch => {
    dispatch({
        type: CLIENTES.DETALLES,
        payload: null
    });
}